export const mainUrl = process.env.REACT_APP_BASE_URL;
export const baseUrl = `${mainUrl}/api/users/v1/`;
